import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingTournamentTent = function (data, level) {
    var config = artConfigBuildings["TournamentTent" + level];
    return BF2GetConfigBasedOutskirtBuilding(config, false, 1);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingTournamentTent.ts
// module id = 2170
// module chunks = 3